export default __webpack_public_path__ + "static/media/sortOnlyRight.042f41a9.svg";